import {
  buildAfterWheelInstagramText,
  buildBeforeWheelInstagramText,
  buildH1TextForGoogleStepAfterWheel,
  determineBeforeWheelInstagramH1,
  getCTAForStep,
} from '../helpers'
import WheelButton from '../../../components/cta/WheelButton'
import * as React from 'react'
import LotteryV2Step from '@tootsweet/model/lottery/LotteryV2Step'
import LotteryV2StepType from '@tootsweet/model/lottery/LotteryV2StepType'
import { goToRedeem } from '../../../redux/actions/lottery'
import { getOrCreateStore } from '../../../redux/store'
import { tt } from '../../../i18n'
import FlexPicture from '../../../components/FlexPicture'
import WheelFormModalContent, {
  WheelFormType,
} from '../02_Form/WheelFormModalContent'
import LotteryConfigurationResponse from '@tootsweet/model/lottery/LotteryConfigurationResponse'

const store = getOrCreateStore()

interface StepTexts {
  beforeWheelH1: string
  beforeWheelText: string | any
  afterWheelText: string
}

const emptyTexts: StepTexts = {
  beforeWheelH1: '',
  beforeWheelText: '',
  afterWheelText: '',
}

export default function renderSocialNetwork(
  config: LotteryConfigurationResponse | undefined | null,
  finalPlaceName: string,
  isIOS: boolean,
  isBeforeWheel: boolean,
  isModal: boolean,
  step: LotteryV2Step | null,
  lotteryStepTag: string | undefined | null,
  prizeLabel: string,
  onNoClicked?: () => void,
  hideImg?: boolean,
  imgName?: string,
  enforceImageWidth?: boolean,
  forceGoogleButton?: boolean,
  switchToGoogleButton?: () => void
) {
  if (step && step.stepType && step.stepType === LotteryV2StepType.Email) {
    return (
      <WheelFormModalContent
        formType={WheelFormType.Email}
        finalPlaceName={finalPlaceName}
      />
    )
  }

  const texts = determineTexts(config, step, isIOS, finalPlaceName, prizeLabel)

  const isAfterWheel = !isBeforeWheel
  const hasBackupStep = !!(
    step &&
    step.backupStep &&
    step.backupStep.length > 0
  )

  return (
    <>
      <div className={`w-margin-bottom ${isModal ? '' : 'cm-pad'}`}>
        {isBeforeWheel && <h2 className="h2">{texts.beforeWheelH1}</h2>}
        {!isBeforeWheel && (
          <h2 className="h2 highlight">
            {tt('you_won_prize', { prizeLabel })}
          </h2>
        )}
      </div>

      <p className={`w-p-big ${isModal ? '' : 'cm-pad'}`}>
        {isBeforeWheel ? texts.beforeWheelText : texts.afterWheelText || ''}
      </p>

      {!hideImg && isBeforeWheel && (
        <FlexPicture
          isModal={isModal}
          src={undefined}
          dataSrc={`image:/cdm/${imgName || 'hearts.png'}`}
          heightPc={0.5}
        />
      )}

      {!hideImg && !isBeforeWheel && (
        <FlexPicture
          isModal={false}
          src={undefined}
          dataSrc={`image:/cdm/${imgName || 'hearts.png'}`}
          heightPc={0.5}
        />
      )}

      {hideImg && <div className="w-margin-bottom"></div>}

      {isModal && (
        <>
          {getCTAForStep(
            step,
            lotteryStepTag || null,
            true,
            isIOS,
            false,
            false,
            isAfterWheel,
            forceGoogleButton,
            step ? step.tag2 : null,
            isAfterWheel
          )}

          {(step?.opt || hasBackupStep) && (
            <div className="w-margin-top-half">
              <span
                className="d-block text-center k-skip"
                onClick={onNoClicked}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                {tt('skip')}
              </span>
            </div>
          )}

          {step &&
            step.stepType === LotteryV2StepType.TripAdvisor &&
            !!step.tag2 && (
              <div
                className="text-center"
                style={{ marginTop: 10 }}
                onClick={switchToGoogleButton}
              >
                {!forceGoogleButton && <p>{tt('no_tripadvisor_account')}</p>}
                {forceGoogleButton && <p>{tt('go_back')}</p>}
              </div>
            )}
        </>
      )}

      {step && (!!step.fbLink || !!step.igLink || !!step.gLink) && (
        <div className="d-block d-flex justify-content-center w-margin-top-half">
          {!!step.fbLink && (
            <a
              href={step.fbLink}
              target="_blank"
              style={{ fontSize: 40, cursor: 'pointer', color: 'black' }}
            >
              <i className="fab fa-facebook"></i>
            </a>
          )}
          {!!step.igLink && (
            <a
              href={step.igLink}
              target="_blank"
              style={{
                fontSize: 40,
                cursor: 'pointer',
                marginLeft: !!step.fbLink ? 10 : 0,
                color: 'black',
              }}
            >
              <i className="fab fa-instagram"></i>
            </a>
          )}
          {!!step.gLink && (
            <a
              href={step.gLink}
              target="_blank"
              style={{
                fontSize: 40,
                cursor: 'pointer',
                marginLeft: !!step.fbLink || !!step.igLink ? 10 : 0,
                color: 'black',
              }}
            >
              <i className="fab fa-google"></i>
            </a>
          )}
        </div>
      )}

      {!isModal && (
        <div className="bottom-after-wheel cm-pad w-padding-bottom">
          {getCTAForStep(
            step,
            lotteryStepTag || null,
            false,
            isIOS,
            false,
            false,
            false,
            undefined,
            undefined,
            isAfterWheel
          )}
          <div style={{ marginTop: 10 }}>
            <WheelButton
              id="k-go-to-gift"
              text={tt('go_to_gift')}
              isInverted={true}
              onClick={() => goToRedeem()(store.dispatch, store.getState)}
            />
          </div>
        </div>
      )}
    </>
  )
}

function determineTexts(
  config: LotteryConfigurationResponse | undefined | null,
  step: LotteryV2Step | null,
  isIOS: boolean,
  finalPlaceName: string,
  prizeLabel: string
): typeof emptyTexts {
  if (!step || !step.stepType) {
    return emptyTexts
  }

  switch (step.stepType) {
    case LotteryV2StepType.Facebook:
      return {
        beforeWheelH1: tt('like_us'),
        beforeWheelText: tt('follow_on_facebook_before_wheel', {
          finalPlaceName: config?.overrideFBVenueName || finalPlaceName,
        }),
        afterWheelText: tt('follow_on_facebook_after_wheel'),
      }

    case LotteryV2StepType.TikTok:
      return {
        beforeWheelH1: tt('follow_us'),
        beforeWheelText: tt('follow_us_tiktok', {
          tikTokUserId: step?.tag || '',
        }),
        afterWheelText: '',
      }

    case LotteryV2StepType.Google:
      return {
        beforeWheelH1: tt('your_opinion_matters'),
        beforeWheelText: (
          <>
            <div className="w-modal-stepper">
              <div className="w-modal-stepper-step">
                <div className="w-modal-stepper-step-number">1</div>
                <span>
                  {tt(
                    step?.alternateWording
                      ? 'tuto_iphone_google_alternate'
                      : 'tuto_iphone_google'
                  )}
                </span>
              </div>
              <div className="w-modal-stepper-step">
                <div className="w-modal-stepper-step-number">2</div>
                <span>
                  {isIOS && (
                    <span>
                      {tt('tuto_iphone_google_2')}{' '}
                      <img
                        className="twic tuto-img-ios-google"
                        data-src={`image:/cdm/img/tutos/tabs_ios.png`}
                        alt="tuto"
                      />
                    </span>
                  )}
                  {!isIOS && <span>{tt('tuto_iphone_google_2_android')}</span>}
                </span>
              </div>
              <div className="w-modal-stepper-step">
                <div className="w-modal-stepper-step-number">3</div>
                <span>{tt('tuto_iphone_google_3')}</span>
              </div>
            </div>
          </>
        ),
        afterWheelText: buildH1TextForGoogleStepAfterWheel(
          finalPlaceName,
          prizeLabel,
          step
        ),
      }

    case LotteryV2StepType.Instagram:
      return {
        beforeWheelH1: determineBeforeWheelInstagramH1(step),
        beforeWheelText: buildBeforeWheelInstagramText(
          config?.overrideIGVenueName || finalPlaceName,
          step,
          isIOS
        ),
        afterWheelText: buildAfterWheelInstagramText(
          config?.overrideIGVenueName || finalPlaceName,
          prizeLabel,
          step
        ),
      }

    case LotteryV2StepType.Snapchat:
      return {
        beforeWheelH1: tt('like_us'),
        beforeWheelText: tt('before_wheel_text_snapchat', { finalPlaceName }),
        afterWheelText: tt('after_wheel_text_snapchat', {
          finalPlaceName,
          prizeLabel,
        }),
      }

    case LotteryV2StepType.TwoSocialNetworks:
      return {
        beforeWheelH1: (step && step.custom2SNTitle) || tt('show_us_love'),
        beforeWheelText:
          (step && step.custom2SNText) ||
          tt('befoe_wheel_text_two_social_networks', { finalPlaceName }),
        afterWheelText: tt('after_wheel_text_two_social_networks', {
          finalPlaceName,
          prizeLabel,
        }),
      }

    case LotteryV2StepType.DownloadApp:
      return {
        beforeWheelH1: tt('before_wheel_h1_download_app'),
        beforeWheelText: tt('before_wheel_text_download_app', {
          finalPlaceName,
        }),
        afterWheelText: tt('after_wheel_text_download_app', {
          finalPlaceName,
          prizeLabel,
        }),
      }

    case LotteryV2StepType.McDoPlus:
      return {
        beforeWheelH1: tt('before_wheel_h1_mcdonalds'),
        beforeWheelText: tt('before_wheel_text_mcdonalds'),
        afterWheelText: tt('after_wheel_text_mcdonalds'),
      }

    case LotteryV2StepType.Deliveroo:
      return {
        beforeWheelH1: tt('before_wheel_h1_deliveroo'),
        beforeWheelText: tt('before_wheel_text_deliveroo'),
        afterWheelText: tt('after_wheel_text_deliveroo'),
      }

    case LotteryV2StepType.UberEats:
      return {
        beforeWheelH1: tt('before_wheel_h1_ubereats'),
        beforeWheelText: tt('before_wheel_text_ubereats', { finalPlaceName }),
        afterWheelText: tt('after_wheel_text_ubereats', {
          finalPlaceName,
          prizeLabel,
        }),
      }

    case LotteryV2StepType.DeliverooUberEats:
      return {
        beforeWheelH1: tt('before_wheel_h1_ubereats_deliveroo'),
        beforeWheelText: tt('before_wheel_text_ubereats_deliveroo', {
          finalPlaceName,
        }),
        afterWheelText: tt('after_wheel_text_ubereats_deliveroo', {
          finalPlaceName,
          prizeLabel,
        }),
      }

    case LotteryV2StepType.TripAdvisor:
      return {
        beforeWheelH1: tt('before_wheel_h1_tripadvisor'),
        beforeWheelText: tt('before_wheel_text_tripadvisor', {
          finalPlaceName,
        }),
        afterWheelText: tt('after_wheel_text_tripadvisor', {
          finalPlaceName,
          prizeLabel,
        }),
      }

    case LotteryV2StepType.CustomLink:
      return {
        beforeWheelH1: step.customLinkTitle || '',
        beforeWheelText: step.customLinkText || '',
        afterWheelText: '',
      }

    case LotteryV2StepType.Staffing:
      return {
        beforeWheelH1: tt('were_hiring_title'),
        beforeWheelText: tt('were_hiring_text'),
        afterWheelText: '',
      }
  }

  return emptyTexts
}
